// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"4d90fc06","133":"72799496","182":"cd367d6b"}[chunkId] + ".chunk.js";
};